import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenForgottenPasswordComponent } from "./components/loren-forgotten-password/loren-forgotten-password.component";
import { LorenForgottenPasswordRoutingModule } from "./loren-forgotten-password-routing.module";
import { LorenEntityFormModule } from "../../shared/modules/loren-entity-form/loren-entity-form.module";

@NgModule({
  declarations: [LorenForgottenPasswordComponent],
  imports: [
    LorenForgottenPasswordRoutingModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    LorenEntityFormModule,
    TranslocoModule,
    MatButton,
  ],
})
export class LorenForgottenPasswordModule {}
